import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const LOGO_WHITE = "https://customer-assets-cm19k8pv.emergentagent.net/job_comms-hub-79/artifacts/oy8i4aw2_Park%20Communications%20Logo%20White.png";
export const LOGO_BLACK = "https://customer-assets-cm19k8pv.emergentagent.net/job_comms-hub-79/artifacts/n6e8lsqd_Park%20Communications%20Logo%20Black.png";
